var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagBrazil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#6DA544"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 4.6958L21.913 12.0001L11.9999 19.3045L2.08691 12.0001L11.9999 4.6958Z",
    fill: "#FFDA44"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 16.174C14.3052 16.174 16.174 14.3052 16.174 12.0001C16.174 9.69489 14.3052 7.82617 12.0001 7.82617C9.69489 7.82617 7.82617 9.69489 7.82617 12.0001C7.82617 14.3052 9.69489 16.174 12.0001 16.174Z",
    fill: "#F0F0F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.91276 11.7393C9.18695 11.7393 8.48649 11.8496 7.82715 12.0545C7.85635 14.3345 9.71279 16.1741 11.9997 16.1741C13.4139 16.1741 14.6628 15.4701 15.4178 14.3943C14.1261 12.7773 12.1385 11.7393 9.91276 11.7393Z",
    fill: "#0052B4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0962 12.7997C16.1464 12.5408 16.1735 12.2737 16.1735 12.0001C16.1735 9.69484 14.3048 7.82617 11.9997 7.82617C10.2796 7.82617 8.80306 8.86684 8.16406 10.3527C8.72891 10.2356 9.31372 10.174 9.91273 10.174C12.337 10.174 14.5301 11.1817 16.0962 12.7997Z",
    fill: "#0052B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagBrazil);
export default __webpack_public_path__ + "static/media/Flag-Brazil.900b8a42d45452e593cfa04971eae013.svg";
export { ForwardRef as ReactComponent };